import { render, staticRenderFns } from "./Onboarder.vue?vue&type=template&id=dd3bd04e&"
import script from "./Onboarder.vue?vue&type=script&lang=js&"
export * from "./Onboarder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports